import '../../assets/index18.css';var g = Object.defineProperty, D = Object.defineProperties;
var N = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var n = (o, e, r) => e in o ? g(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, _ = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && n(o, r, e[r]);
  if (m)
    for (var r of m(e))
      l.call(e, r) && n(o, r, e[r]);
  return o;
}, d = (o, e) => D(o, N(e));
var v = (o, e) => {
  var r = {};
  for (var s in o)
    c.call(o, s) && e.indexOf(s) < 0 && (r[s] = o[s]);
  if (o != null && m)
    for (var s of m(o))
      e.indexOf(s) < 0 && l.call(o, s) && (r[s] = o[s]);
  return r;
};
import { jsx as a } from "react/jsx-runtime";
import { forwardRef as P } from "react";
import { XMarkFarFAIcon as T } from "../Icons/index.js";
import { P as x } from "../../Pill-s4XaUkmY.js";
const y = "DismissibleTag-module__root___qnaQK", F = "DismissibleTag-module__removeIcon___-EpPn", p = {
  root: y,
  removeIcon: F
}, h = P((k, f) => {
  var t = k, {
    className: o,
    size: e = "sm",
    disabled: r,
    children: s,
    onRemove: u,
    withRemoveButton: i = !0,
    removeButtonIcon: j
  } = t, I = v(t, [
    "className",
    "size",
    "disabled",
    "children",
    "onRemove",
    "withRemoveButton",
    "removeButtonIcon"
  ]);
  const b = /* @__PURE__ */ a("div", { className: p.removeIcon, children: /* @__PURE__ */ a(T, {}) });
  return /* @__PURE__ */ a(
    x,
    d(_({
      ref: f,
      size: e,
      disabled: r,
      className: p.root,
      withRemoveButton: i,
      onRemove: u,
      unstyled: !0,
      removeButtonProps: i ? {
        "aria-label": "Remove tag",
        children: b
      } : void 0
    }, I), {
      children: s
    })
  );
});
h.displayName = "DismissibleTag";
export {
  h as DismissibleTag
};
